import { BeatLoader } from './BeatLoader';
import { BEAT_PATTERNS } from '../../../src/constants/danceLoaders';

// 5-6-7-8 count-in
export function CountInLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.countIn} />;
}
